import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '@/components/PageHeader';

export default function BillingCancelPage() {
  return (
    <div>
      <PageHeader title="Checkout canceled" subtitle="No changes were made" />
      <section className="card section">
        <p>You canceled checkout. You can upgrade anytime from the dashboard.</p>
        <Link to="/" className="btn">
          Back to dashboard
        </Link>
      </section>
    </div>
  );
}
